"use client";

import React from "react";
import { useRouter } from "@/lib/useRouter";
import { SetupAuthenticatedProvider } from "@/lib/api/setupUser";
import { useGetAuthenticatedUser } from "@gettactic/helpers/src/hooks/useGetAuthenticatedUser";
import { api } from "@/lib/api/api";
import { AuthenticatedUser } from "@gettactic/api";
import { AppAuthenticatedProvider } from "@gettactic/hooks";
import { ApiSettingsProvider } from "@cmp-src/providers/ApiSettingsProvider";
import { ThemeProvider } from "@gettactic/components/themes";

interface UseAuthenticatedIfExistsProps extends React.PropsWithChildren {
  authenticatedUser?: AuthenticatedUser | null;
}

export const UseAuthenticatedIfExists: React.FC<
  UseAuthenticatedIfExistsProps
> = ({ authenticatedUser, children }) =>
  authenticatedUser ? (
    <AppAuthenticatedProvider api={api} authenticatedUser={authenticatedUser}>
      <ApiSettingsProvider>{children}</ApiSettingsProvider>
    </AppAuthenticatedProvider>
  ) : (
    <>{children}</>
  );

export const SetupLayout: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  // useRequireLogin();
  const router = useRouter();
  const { user: authenticatedUser } = useGetAuthenticatedUser(api);
  const currentStep = router.pathname;
  return (
    <UseAuthenticatedIfExists authenticatedUser={authenticatedUser}>
      {authenticatedUser ? (
        <SetupAuthenticatedProvider authenticatedUser={authenticatedUser}>
          <div className={"tactic-setup-page"}>
            <ThemeProvider
              defaultBrand="base"
              storageKey="ui-theme-new"
              externalBrand="base"
            >
              {children}
            </ThemeProvider>
          </div>
        </SetupAuthenticatedProvider>
      ) : null}
    </UseAuthenticatedIfExists>
  );
};

export const SetupLayoutNoAuth: React.FC<React.PropsWithChildren> = ({
  children
}) => {
  return (
    <div className={"tactic-setup-page"}>
      <ThemeProvider
        defaultBrand="base"
        storageKey="ui-theme-new"
        externalBrand="base"
      >
        {children}
      </ThemeProvider>
    </div>
  );
};
